import { ILicenseRestClient } from "./i-license-rest.client";
import { ILicense } from "../../models/i-license";
import { HostUtil } from "../../utils/host-util";
import { firstValueFrom, Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { ARestClient } from "@zaeper/communication-lib";
import { Injectable } from "@angular/core";

@Injectable()
export class LicenseRestClient extends ARestClient implements ILicenseRestClient {
	constructor(private readonly _httpClient: HttpClient) {
		super();
	}

	getLicenseByCompany(companyId: string): Promise<ILicense> {
		const endpointUrl: string = super.getEndpointUrl(HostUtil.getLicenseApiEndpointUrl(), `v1/company/${companyId}/license`);

		return firstValueFrom(this._httpClient.get(endpointUrl, { withCredentials: true }) as Observable<ILicense>);
	}

	getLicense(licenseId: string): Promise<ILicense> {
		const endpointUrl: string = super.getEndpointUrl(HostUtil.getLicenseApiEndpointUrl(), `v1/license/${licenseId}`);

		return firstValueFrom(this._httpClient.get(endpointUrl, { withCredentials: true }) as Observable<ILicense>);
	}
}
